export enum AgentFeeSheetTableDetailEnum {
    Signed = 'Signed',
    SignedXY = 'Signed X/Y',
    NotSigned = 'Not Signed',
    NotYetSent = 'Not Yet Sent'
}

export enum AgentFeeSheetDetailColorEnum {
    Signed = 'LightGreen',
    SignedXY = 'Yellow',
    NotSigned = 'Orange',
    NotYetSent = 'Orange',
    Blank = 'LightGray'
}
